import { get_feature_flag_property } from './feature_flags';
import { microservicesApiAxios } from './api';

const LOGIN_DETAILS_FLAG = 'idc.account_access_manager_login_details_visible';

/**
 * Starts loading the Account Access Manager login details of the current user for an account.
 * Neither promise ever rejects: when the feature is hidden or the call fails the section is simply not shown.
 *
 * @param {string} accountId
 * @returns {{visible: Promise<boolean>, details: Promise<object|null>}} `visible` resolves once it is known whether the
 *   API is called at all, `details` resolves with the login details (null when hidden or failed).
 */
export function fetchAccountAccessLoginDetails(accountId) {
  const visible = (async () => {
    try {
      return !!(await get_feature_flag_property(LOGIN_DETAILS_FLAG, false));
    } catch (err) {
      console.error('Failed to read the Account Access Manager login details feature flag', err);
      return false;
    }
  })();

  const details = visible.then(async isVisible => {
    if (!isVisible) return null;
    try {
      return await microservicesApiAxios.getIDCAccountAccessLoginDetails(accountId);
    } catch (err) {
      console.error(`Failed to load the Account Access Manager login details of ${accountId}`, err);
      return null;
    }
  });

  return { visible, details };
}

/**
 * @param {string} accountId
 * @returns {Promise<object|null>}
 */
export function loadAccountAccessLoginDetails(accountId) {
  return fetchAccountAccessLoginDetails(accountId).details;
}

/**
 * Puts already generated IDC sign-in URLs back on the links of freshly re-rendered account tabs.
 *
 * @param {Object<string, string>} urlsByRole
 */
export function restoreIdcSignInLinks(urlsByRole) {
  Object.entries(urlsByRole).forEach(([role, url]) => {
    document.querySelectorAll(`a[id="${role}"]`).forEach(link => {
      link.setAttribute('href', url);
      link.textContent = 'Switch Role';
    });
  });
}
